import RocketIcon from '@mui/icons-material/RocketLaunch';
import { LightTooltip } from './LightTooltip';

export const BranchTooltip = ({ branchName }: { branchName: string | undefined }) => {
  return (
    <LightTooltip disableFocusListener title={branchName} style={{ marginLeft: '10px', marginRight: '10px' }}>
      <RocketIcon color="primary" />
    </LightTooltip>
  );
};
